import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss'],
})
export class SearchModalComponent implements OnInit {
  @ViewChild('mymodal') public childModal: ModalDirective;

  isSearchOn = 0;
  user: any;
  name: any;
  phone: any;
  phoneModel: any;
  birthday: any;
  postcode: any;
  email: any;
  membersince: any;
  referPoint: any;
  memberPOint: any;
  prefferedSale: any;
  recieptTotal: any;
  promotionsUsed = [];
  Suserid: any;
  // modalRef:any;
  passcode: FormGroup;
  submitted = false;
  error = '';
  pcode: any = '1212';
  memStatus: any;
  memberType: any;
  type: any;
  availablePromotions = [];
  reciepts = [];
  reciept = [];
  selectedFile = null;
  keyValue: any;
  keydetail: any;
  supAdmin = 0;
  recieptImage: any = '../../../../assets/images/pro.png';
  imagePath: any;
  rcptImg: any;
  modalHeading: any;
  notesArr = [];
  imgUrl: any;
  nameAdmin: any;
  notes: any;
  CuStatus: any;
  actionCust = [];
  character = [];
  enteredPass: any;
  private modalRef;
  selected: any = null;
  selectedTitle: any;
  searchedCust = [];
  template = [];
  cusContryCode: any;
  roleId = 0; //1=> admin, 2 => user
  claimed = 0;
  claimedId: any;
  claimedBy: any;
  adminId: any;
  bdayPromo: any;
  bdayPromoDate: any;
  bdayPromoId: any;
  bday_promo_sms_popup: any;
  send_bday_promo_message_response_otp: any;

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private local: LocalServiceService,
    private router: Router,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    // this.passcode = this.formBuilder.group({
    //   p1: ['', [Validators.required,Validators.minLength(1),Validators.maxLength(1),Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    //   p2: ['', [Validators.required,Validators.minLength(1),Validators.maxLength(1),Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    //   p3: ['', [Validators.required,Validators.minLength(1),Validators.maxLength(1),Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    //   p4: ['', [Validators.required,Validators.minLength(1),Validators.maxLength(1),Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
    // });

    let use = this.local.getUser();
    this.pcode = use.otp;
    if (this.pcode == 0) {
      this.supAdmin = 1;
    }

    this.getProfileDetail();
    this.getTemplates(this.roleId);
    this.getSearchedCustomers();
  }

  // get pIn(){
  //   return this.passcode.controls;
  // }

  getProfileDetail() {
    this.auth.getProfile().subscribe(
      (response: any) => {
        this.nameAdmin = response.body.userName;
        this.adminId = response.body.id;
        this.imgUrl = `http://3.0.142.216:3012/'${response.body.image}`;
        // console.log("yes",this.imgUrl)
      },
      (error) => {
        if (error.status == 401) {
          this.local.logout();
          this.router.navigate(['/']);
        }
      }
    );
  }

  getCutomerNotes() {
    let data = { user_id: this.Suserid };

    this.auth.getCustomerNote(data).subscribe(
      (response: any) => {
        this.notesArr = response.body;
        console.log('nptes', response);
      },
      (e) => {
        if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        } else {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  addNote() {
    if (this.notes == undefined) {
      this.toastr.error('Please enter note');
      return;
    }

    let data = { description: this.notes, user_id: this.Suserid };

    this.auth.addNoteCustomer(data).subscribe(
      (response: any) => {
        this.notesArr = response.body;
        this.notes = '';
        this.toastr.success('Note Added Successfully');
        //  console.log('hello',response);
      },
      (e) => {
        if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        } else {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  deletNote(id) {
    const formData = new FormData();

    formData.append('note_id', id);

    let data = { note_id: id, user_id: this.Suserid };

    this.auth.deleteCustomerNote(data).subscribe(
      (response: any) => {
        // console.log('-------------->',response);
        this.toastr.success('Note Deleted Successfully');
        this.notesArr = response.body;
      },
      (e) => {
        if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        } else {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  showUserModal(modal, memberstatus, type) {
    // alert('-');
    if (type == 'mem') {
      this.modalHeading = 'Member Status';
    } else {
      this.modalHeading = 'Redeem';
    }
    this.enteredPass = undefined;
    // this.modalService.dismissAll();
    this.modalRef = this.modalService.open(modal, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
    });
    this.memStatus = memberstatus;
    this.type = type;
  }

  showReciept(modal) {
    this.recieptImage = '../../../../assets/images/pro.png';
    this.keyValue = undefined;
    this.modalRef = this.modalService.open(modal, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
    });
  }

  onFileSelected(files) {
    console.log(files);
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      // this.message = 'Only images are supported.';
      return;
    }

    // this.editFData['image'].setValue(files[0].name ? files[0].name : '');
    const reader = new FileReader();
    this.imagePath = files;
    this.selectedFile = <File>files[0];
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.recieptImage = reader.result;
      // this.profileImg = reader.result;
    };

    // this.selectedFile = event.target.files[0];
  }

  onUpload() {
    if (this.keyValue == undefined) {
      this.toastr.error('Please enter key Value');
      return;
    }

    if (isNaN(this.keyValue)) {
      this.toastr.error('Please enter numeric value');
      return;
    }

    // if(this.selectedFile == null){
    //   this.toastr.error('Receipt Image is required');
    //   return;
    // }

    const formData = new FormData();

    formData.append('image', this.selectedFile);
    formData.append('totalAmount', this.keyValue);
    formData.append('user_id', this.phone);
    formData.append('detail', this.keydetail);
    // let data = {'image':this.selectedFile,'totalAmount':this.keyValue,'user_id':this.phone};

    this.auth.addReciept(formData, this.phone).subscribe(
      (response: any) => {
        // console.log(response,'----------------');
        this.toastr.success(response.message);
        this.reciepts = response.body.AllBills;
        // this.modalService.dismissAll();
        this.selectedFile = null;
        this.modalRef.close();
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );

    console.log(this.selectedFile); // You can use FormData upload to backend server
  }

  dismiss() {
    // alert();
    this.modalService.dismissAll();
  }

  onOtpChange(event) {
    this.enteredPass = event;
    // console.log(event);
  }

  onSubmit() {
    this.submitted = true;
    if (this.enteredPass == undefined || this.enteredPass == '') {
      this.toastr.error('Please enter correct sub admin password');
      return;
    }
    if (parseInt(this.enteredPass) == this.pcode) {
      // console.log('------------')

      if (this.type == 'mem') {
        this.auth.changeMemberStatus(this.phone, this.memStatus).subscribe(
          (response: any) => {
            this.toastr.success(response.message);
            this.memberType = this.memStatus;
            this.modalRef.close();
            // this.modalService.
            // this.modalService.dismissAll();
            // this.childModal.close()
            console.log('------------', response);
          },
          (e) => {
            if (e.status == 400) {
              this.toastr.error(e.error.message);
            }
          }
        );
      } else {
        let data = { userId: this.Suserid, promoid: this.type };

        this.auth.apply_promotional_vouture(data).subscribe(
          (response: any) => {
            this.toastr.success('Promotion redeemed successfully');
            // this.modalService.dismissAll();
            this.modalRef.close();
            this.availablePromotions = response.body.availablePromotionsWeb;
            this.promotionsUsed = response.body.usedPromotionsWeb;
            // console.log('------------>',response);
          },
          (e) => {
            if (e.status == 401) {
              this.local.logout();
              this.router.navigate(['/admin']);
            } else {
              this.toastr.error(e.error.message);
            }
          }
        );
      }
    } else {
      this.toastr.error('Password is incorrect');
    }
  }

  abc() {}

  saveNum() {
    if (this.user == undefined) {
      this.toastr.error('Please Enter Number');
      return;
    }
    if (isNaN(this.user)) {
      this.toastr.error('Please enter valid member uid');
      return;
    }

    this.auth.getUser(this.user).subscribe(
      (response: any) => {
        if (response.message == 'users Detail') {
          // console.log(response,'---------------------------------user response')
          this.Suserid = response.body.id;
          this.name = response.body.userName;
          this.phone = response.body.phone;
          this.phoneModel = response.body.outlet;
          this.birthday =
            response.body.dateOfBirth == 0 ? '-' : response.body.dateOfBirth;
          this.postcode = response.body.postalCode;
          this.email = response.body.email;
          this.character = response.body.characteristics;

          this.character = this.character.map((data) => {
            if (response.body.futureSmsCategoriesIds.includes(data.id)) {
              data.isSelected = 1;
            } else {
              data.isSelected = 0;
            }

            return data;
          });

          this.recieptTotal = response.body.userPoints;
          this.prefferedSale = response.body.prefredSalesman;
          this.membersince = response.body.memberSince;
          this.memberPOint = response.body.userPoints;
          this.referPoint = response.body.referPoints;
          this.claimed = response.body.isClaimed;
          this.claimedBy =
            response.body.claimedBy == '' || 0
              ? 'N/A'
              : response.body.claimedBy;
          this.claimedId = response.body.claimAdminId;
          this.cusContryCode = response.body.countryCode;
          this.recieptTotal = response.body.totalPoints;
          this.promotionsUsed = response.body.usedPromotionsWeb;
          this.getTemplates(2);
          this.isSearchOn = 1;
          this.memberType = response.body.memberType;
          this.CuStatus =
            response.body.isVerified == 0 ? 'Unverified' : 'Verified';
          this.availablePromotions = response.body.availablePromotionsWeb;
          this.actionCust = response.body.actions;
          this.reciepts = response.body.receipt;
          this.bdayPromo = response.body.bdayPromo;
          this.bdayPromoDate = response.body.bdayPromoDate;
          this.bdayPromoId = response.body.bdayPromoId;
          this.getCutomerNotes();
        }
        console.log('-----', response);
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        } else if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        }
      }
    );

    // this.auth.getUserProfile().subscribe((response:any)=>{console.log('-----',response)})
  }

  searchCu(user) {
    this.user = user;
    this.auth.getUser(this.user).subscribe(
      (response: any) => {
        // console.log(response,'---------------------------------user response')
        if (response.message == 'users Detail') {
          this.Suserid = response.body.id;
          this.name = response.body.userName;
          this.phone = response.body.phone;
          this.phoneModel =
            response.body.outlet == '' ? '-' : response.body.outlet;
          this.birthday =
            response.body.dateOfBirth == 0 ? '-' : response.body.dateOfBirth;
          this.postcode =
            response.body.postalCode == '' ? '-' : response.body.postalCode;
          this.email = response.body.email == '' ? '-' : response.body.email;
          this.recieptTotal = response.body.userPoints;
          this.prefferedSale = response.body.prefredSalesman;
          this.cusContryCode = response.body.countryCode;
          this.membersince = response.body.memberSince;
          this.memberPOint = response.body.userPoints;
          this.referPoint = response.body.referPoints;
          this.character = response.body.characteristics;

          this.character = this.character.map((data) => {
            if (response.body.futureSmsCategoriesIds.includes(data.id)) {
              data.isSelected = 1;
            } else {
              data.isSelected = 0;
            }

            return data;
          });

          // console.log(this.character,'----------------------------------character')

          this.claimed = response.body.isClaimed;
          this.claimedBy =
            response.body.claimedBy == '' || 0
              ? 'N/A'
              : response.body.claimedBy;
          this.claimedId = response.body.claimAdminId;
          this.recieptTotal = response.body.totalPoints;
          this.promotionsUsed = response.body.usedPromotionsWeb;
          this.memberType = response.body.memberType;
          this.availablePromotions = response.body.availablePromotionsWeb;
          this.reciepts = response.body.receipt;
          this.bdayPromo = response.body.bdayPromo;
          this.bdayPromoDate = response.body.bdayPromoDate;
          this.bdayPromoId = response.body.bdayPromoId;
          this.actionCust = response.body.actions;
          this.getTemplates(2);
          this.CuStatus =
            response.body.isVerified == 0 ? 'Unverified' : 'Verified';
          this.isSearchOn = 1;

          this.getCutomerNotes();
        }
        console.log('-----', response);
      },
      (e) => {
        if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        } else {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  getTemplates(role) {
    this.auth.getTemplate(role).subscribe((response: any) => {
      this.template = response.body;
    });
  }

  changeTemp(checked, item) {
    this.selected = item.description;
    this.selectedTitle = item.title;
  }

  sendTemp() {
    if (this.selectedTitle == null) {
      this.toastr.error('Please enter title');
      return;
    }
    if (this.selected == null) {
      this.toastr.error('Please enter description');
      return;
    }

    const formData = new FormData();
    formData.append('title', this.selectedTitle);
    formData.append('description', this.selected);
    formData.append('countryCode', this.cusContryCode);
    formData.append('phoneNumber', this.phone);

    this.auth.sendTemplate(formData).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.selected = null;
        this.selectedTitle = null;
      },
      (e) => {
        if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        } else {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  cancel() {
    this.selectedTitle = null;
    this.selected = null;
  }

  editUser() {
    this.modalService.dismissAll();
    this.router.navigate(['/admin/edit-customer'], {
      queryParams: { uid: this.phone, isVerify: this.CuStatus },
    });
  }
  onImgError(event) {
    event.target.src = '../../../assets/images/default.png';
  }

  onImgGift(event) {
    event.target.src = '../../../assets/images/gift_img_blue.png';
  }

  getSearchedCustomers() {
    this.auth.getLastFiveSearch().subscribe((response: any) => {
      this.searchedCust = response.body;
    });
  }

  onChange(checked, item, index) {
    this.character[index].isAssigned = checked;

    let data = JSON.stringify(this.character);

    const formdata = new FormData();
    formdata.append('userId', this.Suserid);
    formdata.append('characteristicId', data);
    this.spinner.show();

    this.auth.assignChar(formdata).subscribe(
      (response: any) => {
        this.spinner.hide();
        // console.log('------response----',response);
      },
      (e) => {
        this.spinner.hide();
        if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        } else {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  onClaim() {
    let data = { userId: this.Suserid };

    this.auth.Claimed(data).subscribe(
      (response: any) => {
        this.toastr.success(response.message);
        this.claimed = 1;
        this.claimedBy = this.nameAdmin;
        this.claimedId = this.adminId;
      },
      (e) => {
        if (e.status == 401) {
          this.local.logout();
          this.router.navigate(['/admin']);
        } else {
          this.toastr.error(e.error.message);
        }
      }
    );
  }

  showRcpt(modal, img) {
    this.modalRef = this.modalService.open(modal, {
      size: 'lg',
      ariaLabelledBy: 'modal-basic-title',
      backdrop: 'static',
    });
    this.rcptImg = `https://dev.vvip.com.sg:3011/${img}`;
  }

  onErr(event) {
    event.target.src = '../../../assets/images/def.jpg';
  }

  bday_promo_sms(modal) {
    if (this.bdayPromo == 1) {
      // this.toastr.error('Please complete repair process to redeem.');
    } else {
      this.bday_promo_sms_popup = modal;

      Swal.fire({
        title: 'Are you sure?',
        text: 'You want to send SmS',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, send it!',
      }).then((result) => {
        if (result.isConfirmed) {
          this.spinner.show();

          let formData = new FormData();
          formData.append('phone', this.user);
          formData.append('bdayPromoId', this.bdayPromoId);

          this.auth.send_bday_promo_message(formData).subscribe(
            (response: any) => {
              // this.toastr.success(response.message);
              this.spinner.hide();

              // this.modalService.dismissAll();
              this.modalRef = this.modalService.open(
                this.bday_promo_sms_popup,
                {
                  size: 'lg',
                  ariaLabelledBy: 'modal-basic-title',
                  backdrop: 'static',
                }
              );

              this.send_bday_promo_message_response_otp = response.body.otp;
            },
            (e) => {
              if (e.status == 401) {
                this.local.logout();
                this.router.navigate(['/admin']);
              } else {
                this.toastr.error(e.error.message);
              }

              this.spinner.hide();
            }
          );
        }
      });
    }
  }

  verify_bday_sms() {
    if (this.enteredPass == undefined || this.enteredPass == '') {
      this.toastr.error('Please enter OTP.');
      return;
    }

    // console.log(this.enteredPass.length,'-----------------------entered pass')

    // if(this.enteredPass.length < 4) {
    //   this.toastr.error('Please enter all digits.')
    //   return;
    // }

    if (
      this.enteredPass == parseInt(this.send_bday_promo_message_response_otp)
    ) {
      let formData = new FormData();
      formData.append('bdayPromoId', this.bdayPromoId);

      this.auth.bday_promo_redeem_complete(formData).subscribe(
        (response: any) => {
          this.toastr.success(response.message);
          this.bdayPromo = response.body.isRedeemed;
          this.bdayPromoDate = response.body.redeemDate;
          this.bdayPromoId = response.body.id;
          this.modalRef.close();
        },
        (e) => {
          if (e.status == 401) {
            this.local.logout();
            this.router.navigate(['/admin']);
          } else {
            this.toastr.error(e.error.message);
          }
        }
      );
    } else {
      this.toastr.error('You have entered incorrect OTP.');
      return;
    }
  }
}
